module.exports = __webpack_public_path__ + "img/image_3.bb21607f.png";